const MAX_ERRORS = 20;
const errorBuffer = [];

let originalConsoleError = null;

export function initErrorCollector() {
  // Capture console.error calls
  originalConsoleError = console.error;
  console.error = (...args) => {
    pushError(args.map(a => (typeof a === 'object' ? JSON.stringify(a, null, 2) : String(a))).join(' '));
    originalConsoleError.apply(console, args);
  };

  // Capture unhandled errors
  window.addEventListener('error', (e) => {
    pushError(e.message, e.filename, e.lineno, e.colno);
  });

  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    const msg = e.reason instanceof Error ? e.reason.message : String(e.reason);
    pushError(`Unhandled Promise: ${msg}`);
  });
}

function pushError(message, source, line, col) {
  errorBuffer.push({
    timestamp: new Date().toISOString(),
    message,
    source: source || null,
    line: line || null,
    col: col || null,
  });
  if (errorBuffer.length > MAX_ERRORS) errorBuffer.shift();
}

export function getRecentErrors() {
  return [...errorBuffer];
}
